import React, { useState } from "react";
import BaseModal from "../Modals/BaseModal";
import CreatePostCard from "./CreatePost";
import { toast } from "react-toastify";

const EditPostModal = ({
    isOpen,
    onClose,
    post,
    groupId,
    userProfile,
    members,
    onPostUpdated
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handlePostUpdated = async (updatedPost) => {
        try {
            setIsSubmitting(true);

            // For now, just console log the data


            if (onPostUpdated) {
                onPostUpdated(updatedPost);
            }

            // toast.success("Post updated successfully!");
            onClose();
        } catch (error) {
            console.error("Error updating post:", error);
            // toast.error("Failed to update post. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (!isSubmitting) {
            onClose();
        }
    };

    return (
        <BaseModal
            open={isOpen}
            onClose={handleClose}
            title="Edit Post"
            width={800}
            maxHeight="90vh"
        >
            <div style={{ padding: "0" }}>
                <CreatePostCard
                    groupId={groupId}
                    userProfile={userProfile}
                    members={members}
                    isEditMode={true}
                    editPostData={post}
                    onPostUpdated={handlePostUpdated}
                />
            </div>
        </BaseModal>
    );
};

export default EditPostModal;
